import React, { useEffect } from "react";
import { Typography, Button, Select } from "antd";
import { Radio } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
const { Title } = Typography;
const { Option } = Select;

const Header = (props) => {
  const {
    religions,
    viewStyle,
    currentDate,
    onSelect,
    relgionId,
    setCurrentDate,
    onChangeView,
    onChange,
  } = props;
  const intl = useIntl();

  const period = viewStyle === "table" ? "years" : "months";
  const format = viewStyle === "table" ? "YYYY" : "MMMM YYYY";
  useEffect(() => {
    if (onChange) {
      onChange(moment(currentDate).startOf("month"));
    }
  }, [currentDate]);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "10px",
      }}
    >
      <div style={{ display: "flex" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            width: "150px",
            paddingBottom: "5px",
          }}
        >
          <Button
            type="text"
            shape="circle"
            icon={<RightOutlined />}
            onClick={() => {
              setCurrentDate(moment(currentDate).subtract(1, period).format());
            }}
          />
          <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
            {moment(currentDate).format(format)}
          </Title>
          <Button
            type="text"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={() => {
              setCurrentDate(moment(currentDate).add(1, period).format());
            }}
          />
        </div>
        <div style={{ width: "10px" }} />
        <Select
          style={{ width: "200px" }}
          onSelect={onSelect}
          value={relgionId}
        >
          {religions.map((option) => (
            <Option key={option.id} value={option.id}>
              {option.name}
            </Option>
          ))}
        </Select>
      </div>
      <Radio.Group onChange={onChangeView} value={viewStyle}>
        <Radio.Button value={"table"}>
          {intl.formatMessage({
            id: "app.holiday.table",
          })}
        </Radio.Button>
        <Radio.Button value={"calender"}>
          {intl.formatMessage({
            id: "app.holiday.calender",
          })}
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default Header;
